<div class="border-spinner" [ngClass]="{ centered }">
  <span [class]="'border-spinner-loader ' + loaderClass"></span>
</div>
